var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.392088 7.094C0 7.91203 0 8.84265 0 10.7039V16.5167C0 19.1016 0 20.394 0.836838 21.197C1.64356 21.9711 2.92426 21.999 5.42865 22V15.146C5.42865 13.7981 6.55525 12.7751 7.85722 12.7751H12.1429C13.4449 12.7751 14.5715 13.7981 14.5715 15.146V22C17.0758 21.999 18.3565 21.9711 19.1632 21.197C20 20.394 20 19.1016 20 16.5167V10.7039C20 8.84265 20 7.91203 19.6079 7.094C19.2158 6.27598 18.4795 5.67034 17.0068 4.45906L15.5782 3.28407C12.9163 1.09469 11.5854 0 10 0C8.41461 0 7.08367 1.09469 4.42179 3.28407L4.42179 3.28407L2.99322 4.45906C1.52052 5.67034 0.784175 6.27598 0.392088 7.094ZM12.5715 22V15.146C12.5715 14.9796 12.4189 14.7751 12.1429 14.7751H7.85722C7.58124 14.7751 7.42865 14.9796 7.42865 15.146V22H12.5715Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabHome);
export default __webpack_public_path__ + "static/media/tab-home.470fd212efd111f78683fc5f724456fe.svg";
export { ForwardRef as ReactComponent };